import { JourneyEngineConfigs, RouteConfig } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ROUTES } from '@navigation';

import {
	_root,
	requestContact,
	serviceError,
	subscriptionConclusion,
	subscriptionResumeAndAuthorization,
	subscriptionSelectAccount,
	subscriptionPaymentOptions,
	subscriptionTermsAndConditionsBank,
	subscriptionCorporateData,
	intro,
	subscriptionIntegratorData,
	accessDenied,
} from './prisms';

const journeyEngineConfigs: JourneyEngineConfigs<RouteConfig> = {
	navigators: [
		{
			exact: true,
			name: ROUTES.serviceError,
			path: ROUTES.serviceError,
			prism: serviceError.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionPaymentOptions,
			path: ROUTES.subscriptionPaymentOptions,
			prism: subscriptionPaymentOptions.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionSelectAccount,
			path: ROUTES.subscriptionSelectAccount,
			prism: subscriptionSelectAccount.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionTermsAndConditionsBank,
			path: ROUTES.subscriptionTermsAndConditionsBank,
			prism: subscriptionTermsAndConditionsBank.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionResumeAndAuthorization,
			path: ROUTES.subscriptionResumeAndAuthorization,
			prism: subscriptionResumeAndAuthorization.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionConclusion,
			path: ROUTES.subscriptionConclusion,
			prism: subscriptionConclusion.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.requestContact,
			path: ROUTES.requestContact,
			prism: requestContact.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.intro,
			path: ROUTES.intro,
			prism: intro.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionCorporateData,
			path: ROUTES.subscriptionCorporateData,
			prism: subscriptionCorporateData.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionIntegratorData,
			path: ROUTES.subscriptionIntegratorData,
			prism: subscriptionIntegratorData.prismName,
			subRoutes: [],
		},
		{
			default: true,
			exact: true,
			name: 'home',
			path: ROUTES.root,
			prism: _root.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.accessDenied,
			path: ROUTES.accessDenied,
			prism: accessDenied.prismName,
			subRoutes: [],
		},
	],
};

export default journeyEngineConfigs;
